import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { inr } from "@/lib/format";
import { Button } from "@/components/ui/button";

export default function Wishlist() {
  const { items, toggle } = useWishlist();

  return (
    <div className="container-x py-10" data-testid="wishlist-page">
      <p className="eyebrow">SAVED</p>
      <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mt-1">Your Wishlist</h1>
      {items.length === 0 ? (
        <div className="text-center py-20" data-testid="wishlist-empty">
          <p className="text-stone-500">Save the pieces you love and come back to them.</p>
          <Link to="/shop"><Button className="mt-5 bg-stone-900 hover:bg-brand text-white btn-press" data-testid="wishlist-shop-btn">Explore Jewellery</Button></Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
          {items.map((p) => (
            <div key={p.id} className="group bg-white border border-stone-200 hover:border-stone-400 transition-colors" data-testid={`wishlist-item-${p.slug}`}>
              <Link to={`/products/${p.slug}`} className="block aspect-square overflow-hidden bg-stone-50">
                <img src={p.image} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]" />
              </Link>
              <div className="p-4">
                <p className="eyebrow">{p.purity} {p.metal}</p>
                <Link to={`/products/${p.slug}`}><h3 className="font-heading font-medium text-base mt-1 line-clamp-1">{p.title}</h3></Link>
                <div className="flex items-center justify-between mt-2">
                  <span className="font-heading font-semibold">{inr(p.price_min)}</span>
                  <button onClick={() => toggle(p)} className="text-stone-400 hover:text-red-600" data-testid={`wishlist-remove-${p.slug}`} aria-label="Remove">
                    <Heart size={16} fill="currentColor" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
